import { render } from "./FavoritesView.vue?vue&type=template&id=5b14ee6a&scoped=true&ts=true"
import script from "./FavoritesView.vue?vue&type=script&lang=ts"
export * from "./FavoritesView.vue?vue&type=script&lang=ts"

import "./FavoritesView.vue?vue&type=style&index=0&id=5b14ee6a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b14ee6a"]])

export default __exports__